// // import { useState } from "react";
// // import { useRouter } from "next/router";
// // import Image from "next/image";
// // // import opti from "/images/opti.png";
// // // import hidden from "/images/hidden.png";
// // // import eye from "/images/eye.png";
// // import opti from "../images/opti.png";
// // import hidden from "../images/hidden.png";
// // import eye from "../images/eye.png";

// // import { login } from "./services/loginapifunction";
// // import * as Yup from "yup";
// // import { Client_API_URL } from "./config";

// // const Login = () => {
// //   const router = useRouter();
// //   const [userEmail, setUserEmail] = useState("");
// //   const [passwordVisible, setPasswordVisible] = useState(false);
// //   const [userPassword, setUserPassword] = useState("");
// //   const [clientName, setClientName] = useState("");
// //   const [errorMessages, setErrorMessages] = useState({});
// //   const [successMessage, setSuccessMessage] = useState("");

// //   const validationSchema = Yup.object().shape({
// //     userEmail: Yup.string()
// //       .email("Invalid email format")
// //       .required("Email is required"),
// //     userPassword: Yup.string()
// //       .min(6, "Password must be at least 6 characters")
// //       .required("Password is required"),
// //     clientName: Yup.string()
// //       .min(3, "ClientName must be at least 3 characters")
// //       .required("ClientName is required"),
// //   });

// //   const handleSignIn = async (e) => {
// //     e.preventDefault();

// //     try {
// //       // Step 1: Validate form fields
// //       await validationSchema.validate(
// //         { userEmail, userPassword, clientName },
// //         { abortEarly: false },
// //       );

// //       setErrorMessages({});

// //       // Step 2: Call login API
// //       const result = await login(userEmail, userPassword, clientName);

// //       if (result.success) {
// //         const { accessToken, userId, clientId } = result.data;

// //         // ── TOKEN CHECK ───────────────────────────────────────────────────
// //         if (!accessToken || accessToken.trim() === "") {
// //           setErrorMessages({
// //             form: "Authentication failed: Token not found. Please try again.",
// //           });
// //           setTimeout(() => setErrorMessages({}), 3000);
// //           return;
// //         }
// //         // ─────────────────────────────────────────────────────────────────

// //         // Step 3: Token is valid — save to localStorage
// //         localStorage.setItem("token", accessToken);
// //         localStorage.setItem("userId", userId);
// //         localStorage.setItem("clientId", clientId);

// //         // ✅ NEW API ENDPOINT - Send clientId to console application
// //         fetch("http://172.168.100.62:5000/set-client", {
// //           method: "POST",
// //           headers: { "Content-Type": "application/json" },
// //           body: JSON.stringify({ clientId }),
// //         }).catch(err => console.log("Failed to send clientId:", err));

// //         // ✅ NEW LINE: Mark this as an active browser session.
// //         // sessionStorage is automatically cleared when the browser/tab is closed.
// //         // ProtectedRoute checks this flag — if missing on next open, it logs out.
// //         sessionStorage.setItem("session_active", "true");

// //         console.log("Login successful, token, userId, and clientId saved.");

// //         // Step 4: Fetch user roles using the saved token
// //         const response = await fetch(`${Client_API_URL}/getallusers`, {
// //           method: "POST",
// //           headers: {
// //             "Content-Type": "application/json",
// //             Authorization: accessToken,
// //           },
// //           body: JSON.stringify({ userId, clientId }),
// //         });

// //         const userRolesData = await response.json();

// //         if (response.ok) {
// //           if (userRolesData.results && Array.isArray(userRolesData.results)) {
// //             const user = userRolesData.results.find(
// //               (user) => user.userId === userId,
// //             );

// //             if (user) {
// //               // Step 5: Save roles and redirect
// //               localStorage.setItem("roles", JSON.stringify(user.roles));
// //               router.push("/getallclientusers");
// //             } else {
// //               setErrorMessages({ form: "User roles not found." });
// //               setTimeout(() => setErrorMessages({}), 3000);
// //             }
// //           } else {
// //             setErrorMessages({ form: "Unexpected response format." });
// //             setTimeout(() => setErrorMessages({}), 3000);
// //           }
// //         } else {
// //           setErrorMessages({
// //             form: userRolesData.error || "Failed to retrieve user roles",
// //           });
// //           setTimeout(() => setErrorMessages({}), 3000);
// //         }
// //       } else {
// //         setSuccessMessage("");

// //         if (result.status === 202) {
// //           setErrorMessages({ form: "Invalid Password" });
// //         } else if (result.status === 201) {
// //           setErrorMessages({ form: "User email not found" });
// //         } else {
// //           setErrorMessages({
// //             form: result.error || "An error occurred during login",
// //           });
// //         }

// //         setTimeout(() => setErrorMessages({}), 3000);
// //       }
// //     } catch (error) {
// //       if (error.name === "ValidationError") {
// //         const errors = {};
// //         error.inner.forEach((err) => {
// //           errors[err.path] = err.message;
// //           setTimeout(() => {
// //             setErrorMessages((prev) => {
// //               const { [err.path]: _, ...rest } = prev;
// //               return rest;
// //             });
// //           }, 3000);
// //         });
// //         setErrorMessages(errors);
// //       } else {
// //         setErrorMessages({
// //           form: "Error during login. Please try again later.",
// //         });
// //         setTimeout(() => setErrorMessages({}), 3000);
// //       }
// //     }
// //   };

// //   const togglePasswordVisibility = () => {
// //     setPasswordVisible(!passwordVisible);
// //   };

// //   return (
// //     <div className="login-container">
// //       <div className="login-containeron">
// //         <form onSubmit={handleSignIn}>
// //           <Image src={opti} className="login-class" alt="Opti Image" />
// //           <h1 className="login-heading">CRS</h1>
// //           <br />
// //           <div className="logindetails-container">
// //             <label className="login-label">User Email</label>
// //             <input
// //               className="login-input"
// //               type="text"
// //               value={userEmail}
// //               onChange={(e) => setUserEmail(e.target.value)}
// //               required
// //             />
// //           </div>
// //           <div className="logindetails-container">
// //             <label className="login-label">Password</label>
// //             <input
// //               className="login-input"
// //               type={passwordVisible ? "text" : "password"}
// //               value={userPassword}
// //               onChange={(e) => setUserPassword(e.target.value)}
// //               required
// //             />
// //             <div className="eye-icon" onClick={togglePasswordVisibility}>
// //               {passwordVisible ? (
// //                 <Image src={eye} width="24" height="45" alt="eye icon" />
// //               ) : (
// //                 <Image src={hidden} width="24" height="45" alt="hidden icon" />
// //               )}
// //             </div>
// //           </div>
// //           <div className="logindetails-container">
// //             <label className="login-label">Client Name</label>
// //             <input
// //               className="login-input"
// //               type="text"
// //               value={clientName}
// //               onChange={(e) => setClientName(e.target.value)}
// //               required
// //             />
// //           </div>
// //           <center>
// //             {Object.values(errorMessages).map((msg, index) => (
// //               <p key={index} className="error">
// //                 {msg}
// //               </p>
// //             ))}
// //             {successMessage && <p className="success">{successMessage}</p>}
// //           </center>
// //           <button type="submit" className="login-button">
// //             Log In
// //           </button>
// //         </form>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Login;

// import { useState } from "react";
// import { useRouter } from "next/router";
// import Image from "next/image";
// // import opti from "/images/opti.png";
// // import hidden from "/images/hidden.png";
// // import eye from "/images/eye.png";
// //import opti from "../images/opti.png";
// import hidden from "../images/hidden.png";
// import eye from "../images/eye.png";

// import { login } from "./services/loginapifunction";
// import * as Yup from "yup";
// import { Client_API_URL } from "./config";

// const Login = () => {
//   const router = useRouter();
//   const [userEmail, setUserEmail] = useState("");
//   const [passwordVisible, setPasswordVisible] = useState(false);
//   const [userPassword, setUserPassword] = useState("");
//   const [clientName, setClientName] = useState("");
//   const [errorMessages, setErrorMessages] = useState({});
//   const [successMessage, setSuccessMessage] = useState("");

//   const validationSchema = Yup.object().shape({
//     userEmail: Yup.string()
//       .email("Invalid email format")
//       .required("Email is required"),
//     userPassword: Yup.string()
//       .min(6, "Password must be at least 6 characters")
//       .required("Password is required"),
//     clientName: Yup.string()
//       .min(3, "ClientName must be at least 3 characters")
//       .required("ClientName is required"),
//   });

//   const handleSignIn = async (e) => {
//     e.preventDefault();

//     try {
//       // Step 1: Validate form fields
//       await validationSchema.validate(
//         { userEmail, userPassword, clientName },
//         { abortEarly: false },
//       );

//       setErrorMessages({});

//       // Step 2: Call login API
//       const result = await login(userEmail, userPassword, clientName);

//       if (result.success) {
//         const { accessToken, userId, clientId } = result.data;

//         // ── TOKEN CHECK ───────────────────────────────────────────────────
//         if (!accessToken || accessToken.trim() === "") {
//           setErrorMessages({
//             form: "Authentication failed: Token not found. Please try again.",
//           });
//           setTimeout(() => setErrorMessages({}), 3000);
//           return;
//         }
//         // ─────────────────────────────────────────────────────────────────

//         // Step 3: Token is valid — save to localStorage
//         localStorage.setItem("token", accessToken);
//         localStorage.setItem("userId", userId);
//         localStorage.setItem("clientId", clientId);

//         // ✅ NEW API ENDPOINT - Send clientId to console application
//         fetch("http://172.168.100.62:5000/set-client", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ clientId }),
//         }).catch((err) => console.log("Failed to send clientId:", err));

//         // ✅ NEW LINE: Mark this as an active browser session.
//         // sessionStorage is automatically cleared when the browser/tab is closed.
//         // ProtectedRoute checks this flag — if missing on next open, it logs out.
//         sessionStorage.setItem("session_active", "true");

//         console.log("Login successful, token, userId, and clientId saved.");

//         // Step 4: Fetch user roles using the saved token
//         const response = await fetch(`${Client_API_URL}/getallusers`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: accessToken,
//           },
//           body: JSON.stringify({ userId, clientId }),
//         });

//         const userRolesData = await response.json();

//         if (response.ok) {
//           if (userRolesData.results && Array.isArray(userRolesData.results)) {
//             const user = userRolesData.results.find(
//               (user) => user.userId === userId,
//             );

//             if (user) {
//               // Step 5: Save roles and redirect
//               localStorage.setItem("roles", JSON.stringify(user.roles));
//               router.push("/getallclientusers");
//             } else {
//               setErrorMessages({ form: "User roles not found." });
//               setTimeout(() => setErrorMessages({}), 3000);
//             }
//           } else {
//             setErrorMessages({ form: "Unexpected response format." });
//             setTimeout(() => setErrorMessages({}), 3000);
//           }
//         } else {
//           setErrorMessages({
//             form: userRolesData.error || "Failed to retrieve user roles",
//           });
//           setTimeout(() => setErrorMessages({}), 3000);
//         }
//       } else {
//         setSuccessMessage("");

//         if (result.status === 202) {
//           setErrorMessages({ form: "Invalid Password" });
//         } else if (result.status === 201) {
//           setErrorMessages({ form: "User email not found" });
//         } else {
//           setErrorMessages({
//             form: result.error || "An error occurred during login",
//           });
//         }

//         setTimeout(() => setErrorMessages({}), 3000);
//       }
//     } catch (error) {
//       if (error.name === "ValidationError") {
//         const errors = {};
//         error.inner.forEach((err) => {
//           errors[err.path] = err.message;
//           setTimeout(() => {
//             setErrorMessages((prev) => {
//               const { [err.path]: _, ...rest } = prev;
//               return rest;
//             });
//           }, 3000);
//         });
//         setErrorMessages(errors);
//       } else {
//         setErrorMessages({
//           form: "Error during login. Please try again later.",
//         });
//         setTimeout(() => setErrorMessages({}), 3000);
//       }
//     }
//   };

//   const togglePasswordVisibility = () => {
//     setPasswordVisible(!passwordVisible);
//   };

//   return (
//     <div className="login-container">
//       <div className="login-containeron">
//         <form onSubmit={handleSignIn}>
//           {/* <Image src={opti} className="login-class" alt="Opti Image" /> */}
//           <h1 className="login-heading">CRS</h1>
//           <br />
//           <div className="logindetails-container">
//             <label className="login-label">User Email</label>
//             <input
//               className="login-input"
//               type="text"
//               value={userEmail}
//               onChange={(e) => setUserEmail(e.target.value)}
//               required
//             />
//           </div>
//           <div className="logindetails-container">
//             <label className="login-label">Password</label>
//             <input
//               className="login-input"
//               type={passwordVisible ? "text" : "password"}
//               value={userPassword}
//               onChange={(e) => setUserPassword(e.target.value)}
//               required
//             />
//             <div className="eye-icon" onClick={togglePasswordVisibility}>
//               {passwordVisible ? (
//                 <Image src={eye} width="24" height="45" alt="eye icon" />
//               ) : (
//                 <Image src={hidden} width="24" height="45" alt="hidden icon" />
//               )}
//             </div>
//           </div>
//           <div className="logindetails-container">
//             <label className="login-label">Client Name</label>
//             <input
//               className="login-input"
//               type="text"
//               value={clientName}
//               onChange={(e) => setClientName(e.target.value)}
//               required
//             />
//           </div>
//           <center>
//             {Object.values(errorMessages).map((msg, index) => (
//               <p key={index} className="error">
//                 {msg}
//               </p>
//             ))}
//             {successMessage && <p className="success">{successMessage}</p>}
//           </center>
//           <button type="submit" className="login-button">
//             Log In
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;



import { useState } from "react";
import { useRouter } from "next/router";
import Image from "next/image";

// 1. Properly importing the images using your relative paths
import opti from "../images/opti.png";
import hidden from "../images/hidden.png";
import eye from "../images/eye.png";

import { login } from "./services/loginapifunction";
import * as Yup from "yup";
import { Client_API_URL } from "./config";
 
const Login = () => {
  const router = useRouter();
  const [userEmail, setUserEmail] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [userPassword, setUserPassword] = useState("");
  const [clientName, setClientName] = useState("");
  const [errorMessages, setErrorMessages] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
 
  const validationSchema = Yup.object().shape({
    userEmail: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    userPassword: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
    clientName: Yup.string()
      .min(3, "ClientName must be at least 3 characters")
      .required("ClientName is required"),
  });
 
  const handleSignIn = async (e) => {
    e.preventDefault();
 
    try {
      await validationSchema.validate(
        { userEmail, userPassword, clientName },
        { abortEarly: false },
      );
 
      setErrorMessages({});
 
      const result = await login(userEmail, userPassword, clientName);
 
      if (result.success) {
        const { accessToken, userId, clientId } = result.data;
 
        if (!accessToken || accessToken.trim() === "") {
          setErrorMessages({
            form: "Authentication failed: Token not found. Please try again.",
          });
          setTimeout(() => setErrorMessages({}), 3000);
          return;
        }
 
        localStorage.setItem("token", accessToken);
        localStorage.setItem("userId", userId);
        localStorage.setItem("clientId", clientId);
 
        fetch("http://172.168.100.62:5000/set-client", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ clientId }),
        }).catch(err => console.log("Failed to send clientId:", err));
 
        sessionStorage.setItem("session_active", "true");
 
        console.log("Login successful, token, userId, and clientId saved.");
 
        const response = await fetch(`${Client_API_URL}/getallusers`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
          },
          body: JSON.stringify({ userId, clientId }),
        });
 
        const userRolesData = await response.json();
 
        if (response.ok) {
          if (userRolesData.results && Array.isArray(userRolesData.results)) {
            const user = userRolesData.results.find(
              (user) => user.userId === userId,
            );
 
            if (user) {
              localStorage.setItem("roles", JSON.stringify(user.roles));
              router.push("/getallclientusers");
            } else {
              setErrorMessages({ form: "User roles not found." });
              setTimeout(() => setErrorMessages({}), 3000);
            }
          } else {
            setErrorMessages({ form: "Unexpected response format." });
            setTimeout(() => setErrorMessages({}), 3000);
          }
        } else {
          setErrorMessages({
            form: userRolesData.error || "Failed to retrieve user roles",
          });
          setTimeout(() => setErrorMessages({}), 3000);
        }
      } else {
        setSuccessMessage("");
 
        if (result.status === 202) {
          setErrorMessages({ form: "Invalid Password" });
        } else if (result.status === 201) {
          setErrorMessages({ form: "User email not found" });
        } else {
          setErrorMessages({
            form: result.error || "An error occurred during login",
          });
        }
 
        setTimeout(() => setErrorMessages({}), 3000);
      }
    } catch (error) {
      if (error.name === "ValidationError") {
        const errors = {};
        error.inner.forEach((err) => {
          errors[err.path] = err.message;
          setTimeout(() => {
            setErrorMessages((prev) => {
              const { [err.path]: _, ...rest } = prev;
              return rest;
            });
          }, 3000);
        });
        setErrorMessages(errors);
      } else {
        setErrorMessages({
          form: "Error during login. Please try again later.",
        });
        setTimeout(() => setErrorMessages({}), 3000);
      }
    }
  };
 
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };
 
  return (
    <div className="login-container">
      <div className="login-containeron">
        <form onSubmit={handleSignIn}>
          {/* 2. Passing the imported variable 'opti' to src */}
          <Image src={opti} className="login-class" alt="Opti Image" />
          
          <h1 className="login-heading">CRS</h1>
          <br />
          <div className="logindetails-container">
            <label className="login-label">User Email</label>
            <input
              className="login-input"
              type="text"
              value={userEmail}
              onChange={(e) => setUserEmail(e.target.value)}
              required
            />
          </div>
          <div className="logindetails-container">
            <label className="login-label">Password</label>
            <div className="password-input-wrapper">
              <input
                className="login-input password-input"
                type={passwordVisible ? "text" : "password"}
                value={userPassword}
                onChange={(e) => setUserPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="eye-icon"
                onClick={togglePasswordVisibility}
                aria-label={passwordVisible ? "Hide password" : "Show password"}
              >
                {/* 3. Passing the imported variables 'eye' and 'hidden' to src */}
                {passwordVisible ? (
                  <Image src={eye} alt="eye icon" />
                ) : (
                  <Image src={hidden} alt="hidden icon" />
                )}
              </button>
            </div>
          </div>
          <div className="logindetails-container">
            <label className="login-label">Client Name</label>
            <input
              className="login-input"
              type="text"
              value={clientName}
              onChange={(e) => setClientName(e.target.value)}
              required
            />
          </div>
          <center>
            {Object.values(errorMessages).map((msg, index) => (
              <p key={index} className="error">
                {msg}
              </p>
            ))}
            {successMessage && <p className="success">{successMessage}</p>}
          </center>
          <button type="submit" className="login-button">
            Log In
          </button>
        </form>
      </div>
    </div>
  );
};
 
export default Login;